import React, { useState } from 'react';

import { UiComponent, UserGroupComponent } from 'components';
import { usePageOption } from 'hooks';
import { UserGroupQuery } from 'queries';
import { SearchUserGroupFilterType } from 'types';

function List() {
  const pageState = usePageOption(20);
  const [filter, setFilter] = useState<SearchUserGroupFilterType>({});

  const { data } = UserGroupQuery.useGetAll({
    page: pageState.pageOption.page,
    size: pageState.pageOption.size,
    ...filter,
  });

  const handleFilter = (next: SearchUserGroupFilterType) => {
    setFilter(next);
    pageState.handlePage({ ...pageState.pageOption, page: 1 });
  };

  return (
    <>
      <UiComponent.PageTitle>회원 그룹 관리</UiComponent.PageTitle>
      <UserGroupComponent.List
        {...pageState}
        handleFilter={handleFilter}
        totalPage={data?.totalPages || 1}
        data={data?.data || []}
      />
    </>
  );
}

export default List;
